import { Grid, useMediaQuery } from "@mui/material";
import { ArrayField, Datagrid, ReferenceField, TextField } from "react-admin";

import { settings } from "app";
import { administrationRequests } from "api/administrationApi";
import { SectionTitle } from "features/SectionTitle";

const UniversitiesSection = () => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));

  return (
    <>
      <SectionTitle
        paddingY={2}
        title="Университети"
        textAlign="center"
      />
      <Grid
        container
        spacing={2}
        sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
      >
        <Grid
          item
          xs={12}
        >
          <ArrayField
            source="universities"
            label="Университети"
          >
            <Datagrid
              bulkActionButtons={false}
              size="small"
              rowClick={false}
              sx={settings.style.detailsDatagrid}
            >
              <ReferenceField
                label="Университет"
                source="universityId"
                reference={administrationRequests.getUniversitiesSelect()}
                sortable={false}
              >
                <TextField
                  source="name"
                  label="Университет"
                />
              </ReferenceField>
              <TextField
                label="Приоритет"
                source="priority"
                sortable={false}
                emptyText="-"
              />
            </Datagrid>
          </ArrayField>
        </Grid>
      </Grid>
    </>
  );
};

export default UniversitiesSection;
